<template>
  <div class="hello">
    <v-content>
      <v-container fluid fill-height>
        <v-flex xs12>
          <v-layout column align-center>
            <v-img :src="image" width="400"></v-img>
            <br />
            <br />
          </v-layout>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
              <h1>{{ msg }}</h1>
              <h2>Utente e Password</h2>

              <v-form ref="form" lazy-validation>
                <v-text-field
                  label="Utente"
                  v-model="utente"
                  required
                ></v-text-field>

                <v-text-field
                  v-on:keyup="pwdup"
                  label="Password"
                  v-model="password"
                  :type="'password'"
                  required
                ></v-text-field>

                <v-btn @click="submit">Conferma</v-btn>

                <v-btn @click="clear">Annulla</v-btn>
              </v-form>

              <v-alert v-if="errors" type="warning" :value="true">{{
                errors
              }}</v-alert>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-container>
    </v-content>

    <DialogOperationRunning
      :dialogTitle="operationRunningTitle"
      :dialogMessage="progressMessage"
      :dialog.sync="progressMessageEnable"
      v-bind:isactive="progressMessageEnable"
    />

    <DialogError
      :dialogTitle="errorDialogTitle"
      :dialogMessage="errorMessage"
      :dialogError.sync="errorMessageEnable"
    />
  </div>
</template>

<script src="https://unpkg.com/vue/dist/vue.js"></script>
<script src="https://unpkg.com/vuetify/dist/vuetify.js"></script>

<script>
/* eslint-disable */

import axios from "axios";
import DialogOperationRunning from "@/components/DialogOperationRunning";
import DialogError from "@/components/DialogError";
import mixinCommon from "@/mixin/MixingCommonComp.js";

export default {
  mixins: [mixinCommon],
  components: {
    DialogOperationRunning,
    DialogError,
  },
  dialog: false,
  sound: true,
  widgets: false,
  name: "Login",
  data() {
    return {
      operationRunningTitle: "INFO",
      errorDialogTitle: "Error",
      valid: true,
      loading: true,
      msg: "Login",
      utente: "",
      password: "",
      errors: null,
      image: require("@/assets/logo_vitech.png"),
    };
  },
  methods: {
    pwdup: function (e) {
      if (e.keyCode === 13) {
        //alert('Enter was pressed');
        this.submit();
      } //else if (e.keyCode === 50) {
      //alert('@ was pressed');
      //}
      //this.log += e.key;
    },
    submit() {
      console.log("submit");
      var parameters = {};
      parameters.utente = this.utente;
      parameters.password = this.password;

      this.$store.commit("setProgressMessage", "Accesso in corso");

      //this.$store.commit("setUUID", this.$session.get("uuid"))
      this.$store.dispatch("login/richiestaLogin", parameters).then(
        (response) => {
          console.log("response >>" + response);
          console.log("response >> " + JSON.stringify(response));

          if (response.result == "KO"||
                  response.result == "Wrong username") {
            console.log("response KO ");
            this.errors = response.message || "Utente o password non validi";
            this.$store.commit("setProgressMessage", null);
            this.$store.commit("setErrorMessage", this.errors);
          } else {
            this.$session.start();

            console.log("response.uuid >> " + response.session_uu);
            //this.$session.set("ad_client_id",response.data.ad_client_id)
            this.$session.set("uuid", response.session_uu);
            this.$store.commit("setNavBarPermanent", true);
            this.$store.commit("setUUID", response.session_uu);
            this.$session.set("ad_client_id", response.ad_client_id);
            this.$session.set("ad_user_id", response.ad_user_id);
            this.$session.set("ad_org_id", response.ad_org_id);
            this.$session.set("c_bpartner_id", response.c_bpartner_id);
            this.$session.set("name", response.name);

            this.$store.commit("setNavBarPermanent", true);
            this.$router.push({ path: "/foglioOre" });
            this.$store.commit("setProgressMessage", null);
            let parameters = {};
            parameters.idempiereRestPath = "vitech/abilitazioneModificaOre";
            this.$store
              .dispatch("callIdempiereRest", parameters)
              .then((response) => {
                console.log("abilitazioneModificaOre response >> " + JSON.stringify(response));
                this.$store.commit("setAbilitatazioneModificaOre",response.data.data.permettimodificaore=="Y")
                console.log(this.$store.state.abilitatazioneModificaOre)
              });
          }
        },
        (error) => {
          console.log("Errore di login");
          console.log(error);
          this.$store.commit("setProgressMessage", null);
          this.$store.commit(
            "setErrorMessage",
            (error && error.friendlyMessage) ||
              "Impossibile accedere: si è verificato un errore imprevisto."
          );
        }
      );
    },
    clear() {
      console.log("clear");
      this.utente = "";
      this.password = "";
    },
  },
  // Fetches posts when the component is created.
  created() {
    //console.log(this.$ridproxy);
    this.$store.commit("setProgressMessage", null);
  },
  computed: {
    progressMessage: function () {
      return this.$store.state.progressMessage;
    },
    progressMessageEnable: function () {
      if (this.$store.state.progressMessage == null) {
        return false;
      } else {
        return true;
      }
    },
    errorMessageEnable: function () {
      if (this.$store.state.errorMessage == null) {
        //console.log("false")
        return false;
      } else {
        //console.log("true")
        return true;
      }
    },
    errorMessage: function () {
      return this.$store.state.errorMessage;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.loading-dialog {
  background-color: #303030;
}
</style>
